const visitedAllPages = (pages, ui) => {
    return pages.pages_visited.length >= ui.length;
  };

export default visitedAllPages